module.exports = __webpack_public_path__ + "static/media/Plane.2b1dd34c.png";